import React from 'react';
import { Currency, CURRENCY_LABEL } from '../../Data/PricingData';

interface CurrencySelectProps {
    currency: Currency;
    onChange: (currency: Currency) => void;
}

const CurrencySelect: React.FC<CurrencySelectProps> = ({ currency, onChange }) => (
    <label className="currency-select">
        <span className="sr-only">Currency</span>
        <select value={currency} onChange={e => onChange(e.target.value as Currency)}>
            {(Object.keys(CURRENCY_LABEL) as Currency[]).map(c => (
                <option key={c} value={c}>{CURRENCY_LABEL[c]}</option>
            ))}
        </select>
    </label>
);

export default CurrencySelect;
